import * as Yup from "yup";

export const validationSchema = Yup.object({
    upload_signed_agreement: Yup.string().required("Upload signed agreement is required")
})